import React from 'react';
import styled from 'styled-components';

import Icon from '@components/dataDisplay/Icons/Icon';

const IconWrap = styled.div`
  position: absolute;
  top: 50%;
  transform: translateX(0) translateY(-50%);
  right: -6px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  z-index: 1;

  &:hover {
    background-color: var(--inkColor);
    cursor: var(--hoverCursorURL), pointer;
  }
`;

type Props = {
  listeners?: any;
  attributes?: any;
  style?: React.CSSProperties;
  [propsName: string]: any;
};

function DeleteIconSec({ style, ...props }: Props) {
  return (
    <IconWrap style={style} {...props} className="xIcon">
      <Icon name="X12" color="var(--subTextColor)" />
    </IconWrap>
  );
}

export default DeleteIconSec;
